import {
    PREFERRED_MANAGEMENT_ZONE_FILL_LAYER,
    PREFERRED_MANAGEMENT_ZONE_LINE_LAYER,
} from "@/lib/map/layers";
import SimpleLayer from "./SimpleLayer";
import { useCallback, useMemo } from "react";
import useRequest from "@/lib/request/useRequest";
import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";

function ManagementZoneLayers() {
    const { fieldId } = useFieldDashboard() ?? {};
    const { useGetRequest, downloadFile } = useRequest();

    const managementZonesQuery = useGetRequest<
        {
            id: string;
            name: string;
            is_primary: boolean;
        }[]
    >({
        url: `fields/${fieldId}/management_zones/`,
        enabled: !!fieldId,
    });

    const primaryManagementZone = useMemo(
        () => managementZonesQuery?.data?.find((layer) => layer.is_primary),
        [managementZonesQuery?.data],
    );

    const onDownloadManagementZones = useCallback(async () => {
        if (!primaryManagementZone) return;

        await downloadFile(
            `management_zones/${primaryManagementZone?.id}/download/`,
            primaryManagementZone.name,
        );
    }, [downloadFile, primaryManagementZone]);

    return (
        <>
            <SimpleLayer
                name="Management Zones"
                layerNames={[
                    PREFERRED_MANAGEMENT_ZONE_FILL_LAYER.id,
                    PREFERRED_MANAGEMENT_ZONE_LINE_LAYER.id,
                ]}
                disabled={!primaryManagementZone}
                onDownload={onDownloadManagementZones}
            />
        </>
    );
}

export default ManagementZoneLayers;
